module.exports = __webpack_public_path__ + "static/media/twoyear.5c4a9457.png";